import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AppointmentProvider } from "@/context/AppointmentContext";
import { Navbar } from "@/components/layout/Navbar";
import { Footer } from "@/components/layout/Footer";
import { FloatingButtons } from "@/components/layout/FloatingButtons";
import { ScrollToTop } from "@/components/layout/ScrollToTop";
import { AppointmentDialog } from "@/components/AppointmentDialog";
import { Toaster } from "@/components/ui/sonner";
import Home from "@/pages/Home";
import ServicesPage from "@/pages/ServicesPage";
import AboutPage from "@/pages/AboutPage";
import ContactPage from "@/pages/ContactPage";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AppointmentProvider>
          <ScrollToTop />
          <Navbar />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/services" element={<ServicesPage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/contact" element={<ContactPage />} />
          </Routes>
          <Footer />
          <FloatingButtons />
          <AppointmentDialog />
          <Toaster position="top-center" richColors />
        </AppointmentProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
